"use client";
import { jsx } from "react/jsx-runtime";
import { sharedHandler } from "../../../shared/sharedHandler/sharedHandler.js";
import { em } from "@mantine/core";
import { useElementSize, useMergedRef } from "@mantine/hooks";
import { forwardRef, useState, useEffect, memo } from "react";
import BackgroundImage from "./BackgroundImage.js";
import FigureImage from "./FigureImage.js";
const _Image = forwardRef((props, ref) => {
  const {
    children,
    placeholder,
    height = "100%",
    width = "100%",
    fit = "cover",
    caption,
    src,
    landscape,
    portrait,
    alt,
    title,
    className,
    objectPosition,
    portraitObjectPosition,
    orientation = "auto",
    overlay,
    sizes,
    overlayOpacity,
    ...rest
  } = props;
  const [isReady, setIsReady] = useState(orientation !== "auto");
  const [image, setImage] = useState(src || "");
  const [position, setPosition] = useState(objectPosition);
  const { ref: sizeRef, width: containerWidth, height: containerHeight } = useElementSize();
  const mergedRef = useMergedRef(ref, sizeRef);
  useEffect(() => {
    switch (orientation) {
      case "landscape":
        setImage(landscape || src || "");
        break;
      case "portrait":
        setImage(portrait || src || "");
        setPosition(portraitObjectPosition);
        break;
      default:
        if (containerWidth > 0 && containerHeight > 0) {
          if (src) {
            setImage(src);
            setPosition(objectPosition);
          }
          if (containerWidth > containerHeight && landscape) {
            setImage(landscape);
          } else if (containerWidth <= containerHeight && portrait) {
            setImage(portrait);
            setPosition(portraitObjectPosition);
          }
        }
        break;
    }
    if (!isReady) {
      setIsReady(true);
    }
  }, [containerWidth, containerHeight, objectPosition, portraitObjectPosition]);
  return children ? /* @__PURE__ */ jsx(
    BackgroundImage,
    {
      ...rest,
      src: image,
      className,
      loaded: isReady,
      ref: mergedRef,
      width: width || em(containerWidth),
      height: height || em(containerHeight),
      alt,
      title,
      objectPosition: position,
      overlay,
      overlayOpacity,
      sizes,
      children
    }
  ) : /* @__PURE__ */ jsx(
    FigureImage,
    {
      ...rest,
      sizes,
      loaded: isReady,
      src: image,
      height,
      width,
      fit,
      caption,
      placeholder,
      className,
      alt,
      title,
      objectPosition: position,
      containerWidth,
      ref: mergedRef,
      overlay,
      overlayOpacity
    }
  );
});
_Image.displayName = "Image";
const Image = sharedHandler(memo(_Image));
Image.displayName = _Image.displayName;
export {
  Image as default
};
